document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initCartPromoCarousel();
  }, 1000);
});

function initCartPromoCarousel() {
  const cartPromo = [...document.querySelectorAll('[js-ajax-cart="promoSwiper"]')];

  let cartPromoSwiper = {};

  cartPromo.forEach((promo) => {
    cartPromoSwiper = new Swiper(promo, {
      slidesPerView: 1,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  });

}

/**
 * Shopify product's variatn price update on variant update event
 */
document.querySelectorAll('select.single-option-selector').forEach(item => {

  /**
   * Init event hooks
   */
  item.addEventListener('change', () => {

    const variant_selectors = document.querySelectorAll('select.variant-selection__variants');

    /**
     * 2 product_forms and second element is target element
     */
    if (variant_selectors && variant_selectors.length > 1) {

      const variant_selector = variant_selectors[1];
      const variant_price = variant_selector.selectedOptions[0].getAttribute('data-price-money');
      const compare_at_price = variant_selector.selectedOptions[0].getAttribute('data-compare_at_price-money');
      /**
       * @debug
       */
      console.log(compare_at_price);

      const default_currency = document.querySelector('.localization.header-menu__disclosure .selectors-form__item.selectors-form__currency').getAttribute('data-default-shop-currency');

      const variant_price_box = document.querySelector('.bold_option_price_display');

      /**
       * Remove all other currency attributes
       */
      document.querySelectorAll('#currency-list-header__selector-form--top-bar button').forEach(currency_button => {
        variant_price_box.removeAttribute(`data-currency-${String(currency_button.value).toLowerCase()}`);
      });
      
      /**
       * Update variant price in default currency
       */
      variant_price_box.setAttribute('data-currency-original', `${variant_price} ${default_currency}`);
      variant_price_box.setAttribute(`data-currency-${String(default_currency).toLowerCase()}`, `${variant_price} ${default_currency}`);
      variant_price_box.innerHTML = `${variant_price} ${default_currency}`;
      

      /**
       * If compare_at_price exist
       */
      if (compare_at_price != "") 
      {
        const variant_compare_at_price_box = document.querySelector('.compare-at-price .bold_option_price_display');
        /**
         * Remove all other currency attributes
         */
        document.querySelectorAll('#currency-list-header__selector-form--top-bar button').forEach(currency_button => {
          variant_compare_at_price_box.removeAttribute(`data-currency-${String(currency_button.value).toLowerCase()}`);
        });
        
        /**
         * Update variant price in default currency
         */
        variant_compare_at_price_box.setAttribute('data-currency-original', `${compare_at_price} ${default_currency}`);
        variant_compare_at_price_box.setAttribute(`data-currency-${String(default_currency).toLowerCase()}`, `${compare_at_price} ${default_currency}`);
        variant_compare_at_price_box.innerHTML = `${compare_at_price} ${default_currency}`;
      }
      

      /**
       * Excute the curreny switcher
       */
      const current_currency_selector = document.querySelector('.localization.header-menu__disclosure .selectors-form__item.selectors-form__currency .disclosure__toggle.disclosure__toggle--currency .currency-code');

      if (current_currency_selector) {
        const current_currency = current_currency_selector.innerHTML;

        if (current_currency != default_currency) document.querySelector(`#currency-list-header__selector-form--top-bar button[value="${default_currency}"]`)?.click();
        document.querySelector(`#currency-list-header__selector-form--top-bar button[value="${current_currency}"]`)?.click();

      }
    }
  })
})

/* Estimate Shipping */
var estimateRefresh = setInterval(function(){
  if($('.estimate-st__automatic').length > 0){

    $('.estimate-st__automatic').detach().prependTo('.purchase-details');
    
    clearInterval(estimateRefresh);
  }
});


// Badge Rating on Mobile
$(document).ready(function(){
  if($(window).width() <= 767){
    badgeRatingToMobile();
  }
});
$(window).on('resize', function(){
   var win = $(this);
   if(win.width() <= 767){
     badgeRatingToMobile();
   }
   else{
     badgeRatingToDesktop();
   }
});
function badgeRatingToMobile(){
  var badgeRating = $('.product__information .jdgm-preview-badge').parent().parent().parent();
  if( badgeRating.attr('data-device') != "mobile"){
    badgeRating.attr('data-device','mobile');
    badgeRating.detach();
    $('.hide-on-large .product-block--title').before(badgeRating);
  }
}
function badgeRatingToDesktop(){
  var badgeRating = $('.product_section .jdgm-preview-badge').parent().parent().parent();
  if( badgeRating.attr('data-device') != "desktop"){
    badgeRating.attr('data-device','desktop');
    badgeRating.detach();
   $('.product__information .product-block--title').before(badgeRating);
  }
}
// All Reviews Home

// ComparePrice
var prevCp = "";
var cpRefresh = setInterval(function(){
  let newCp = $('[data-compare-at-price] .bold_option_price_display').text();

  if(newCp){
    $('.price-top-wrapper .value').text(newCp);
    
    const string1 =  $('[data-compare-at-price] .bold_option_price_display').text();
    const string2 =  $('[data-price] .bold_option_price_display').text();
    // Remove non-numeric characters and parse as a float
    const numericValue1 = parseFloat(string1.replace(/[^0-9.-]+/g, ''));
    const numericValue2 = parseFloat(string2.replace(/[^0-9.-]+/g, ''));

    if(numericValue1 != numericValue2){
      let saveAmount = numericValue1 - numericValue2;
      let saveAmountFormattedMoney = formatShopifyMoney(saveAmount, Shopify.currency.active);
      
      $('.price-savings .amount').text(saveAmountFormattedMoney);
    }
  }
},50);


// var buttonPriceRefresh = setInterval(function(){
//   let price = $('.price-ui .price .money').text();
//   if($('.price.money').length>0){
//     price = $('.price.money').text();
//   }
//   $('.button--add-to-cart .money').text(price);
// },50);

var buttonPriceRefresh = setInterval(function() {
  let price = $('.price-ui .price .money').text();

  // Check if there's a specific price to use
  if ($('.price.money').length > 0) {
    price = $('.price.money').text();
  }

  // Remove non-numeric characters and parse the price as a float
  let numericPrice = parseFloat(price.replace(/[^0-9.-]+/g, ''));

  // Sum addon__product-price values only for selected add-ons
  let addonSum = 0;
  $('.addon__product-card.selected-addon .addon__product-price').each(function() {
    const addonPriceString = $(this).text();
    const addonPriceNumeric = parseFloat(addonPriceString.replace(/[^0-9.-]+/g, ''));
    addonSum += addonPriceNumeric;
  });

  // Add the addonSum to the numericPrice
  let totalPrice = numericPrice + addonSum;

  // Format the total price to display correctly
  let formattedTotalPrice = formatShopifyMoney(totalPrice, Shopify.currency.active);

  // Update the button price with the total price
  $('.button--add-to-cart .money').text(formattedTotalPrice);
}, 50);


function formatShopifyMoney(amount, currency = 'USD') {
    const formattedAmount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    }).format(amount);

    return formattedAmount;
}


// Banner Autorotate
// Function to slide the element
function slideNext() {
  const flkty = Flickity.data('.slideshow-classic');

  if(flkty){
    flkty.next();
  }
  
}

// Set an interval to slide the element every 7 seconds (7000 milliseconds)
setInterval(slideNext, 7000);

$(document).ready(function(){
  $('.remaining-thumbnails').on('click', function(){
    document.querySelector('.product-gallery__image.is-selected a[data-fancybox]')?.click();
  });
});

$(document).ready(function(){
  $('.station-tabs-tabset .station-tabs-default-tabpanel .station-tabs-tabcontent').addClass("view-more");
  $('.station-tabs-tabset').removeClass('mod-horizontal');
  $('.station-tabs-tabset').addClass('mod-vertical');
});

var waitModVertical = setInterval(function() {
  if($('.mod-horizontal')){
    $('.mod-horizontal').addClass('mod-vertical');
    $('.mod-horizontal').removeClass('mod-horizontal');
  }
},20)

$(document).ready(function(){
  var waitForElR = setInterval(function() {
    if($('.product-recommendations .jdgm-prev-badge__text').length > 0){  
      var spanElement = $('.product-recommendations .jdgm-prev-badge__text');
      var spanContent = spanElement.html();
      var lastNbspIndex = spanContent.lastIndexOf('&nbsp;');
      
      if (lastNbspIndex !== -1) {
        var updatedContent = spanContent.slice(0, lastNbspIndex) + '&nbsp;<br>' + spanContent.slice(lastNbspIndex + 6);
        updatedContent = updatedContent.replace(/\|/g, '');
        spanElement.html(updatedContent);
      }
      clearInterval(waitForElR);
    }
  }, 1500);


var waitForElR1 = setInterval(function () {
  var slides = $(".featured-products__slide");

  if (slides.length > 0) {
    slides.each(function () {
      var spanElement = $(this).find(".jdgm-prev-badge__text");

      if (spanElement.length > 0) {
        var spanContent = spanElement.html();
        var lastNbspIndex = spanContent.lastIndexOf("&nbsp;");

        if (lastNbspIndex !== -1) {
          var updatedContent = spanContent.slice(0, lastNbspIndex) + "&nbsp;<br>" + spanContent.slice(lastNbspIndex + 6);
          updatedContent = updatedContent.replace(/\|/g, '');
          spanElement.html(updatedContent);
        }
      }
    });

    clearInterval(waitForElR1);
  }
}, 1500);


  
});

var waitForElRM = setInterval(function() {

  
if($(".station-tabs-tabset .station-tabs-default-tabpanel")){
    $(".station-tabs-tabset .station-tabs-default-tabpanel").append('<p class="read-more-btn read-more"><span>+</span> Read more</p>');
    $('p.read-more-btn').on('click',function() {
      if($('p.read-more-btn').hasClass("read-more")){
        $(this).removeClass("read-more");
        $(this).addClass("read-less");
        $(this).html("<span>-</span> Read less");
        $('.station-tabs-tabset .station-tabs-default-tabpanel .station-tabs-tabcontent').css("height", "unset");
        $('.station-tabs-tabset .station-tabs-default-tabpanel .station-tabs-tabcontent').removeClass("view-more");
      }
      else {
        $(this).removeClass("read-less");
        $(this).addClass("read-more");
        $(this).html("<span>+</span> Read more");
        $('.station-tabs-tabset .station-tabs-default-tabpanel .station-tabs-tabcontent').css("height", "290px");
        $('.station-tabs-tabset .station-tabs-default-tabpanel .station-tabs-tabcontent').addClass("view-more");
        $('html,body').animate({ scrollTop: $("#to-first-tab").offset().top }, 'slow');
      }
    });
    clearInterval(waitForElRM);
}

}, 10);



$(document).ready(function(){
  $(document).on('click','.button.add_to_cart.checkout',function(){
    window.location.href = "/checkout";
  });
})


document.addEventListener("DOMContentLoaded", function () {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    const offset = 10; // Adjust this value based on your header height

    anchorLinks.forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            const targetId = this.getAttribute("href");
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                e.preventDefault();
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
  let isTextClamped = false;
  let clickHandlerAttached = false;

  function toggleTextClamp(enable) {
    const p = document.querySelector(
      ".collection__description p:first-of-type"
    );
  
    if (!p) return;
  
    if (enable) {
      p.style.display = "-webkit-box";
      p.style.webkitLineClamp = "3";
      p.style.webkitBoxOrient = "vertical";
      p.style.overflow = "hidden";
    } else {
      p.style.display = "block";
      p.style.webkitLineClamp = "";
      p.style.webkitBoxOrient = "";
      p.style.overflow = "";
    }
  }

  function initTextClamp() {
    const descriptionContainer = document.querySelector('.collection__description.content');
    const descriptionLink = document.querySelector('.collection__description.content a');
    
    if(window.innerWidth <= 767){
      // Add gradient effect initially
      if(descriptionContainer) {
        descriptionContainer.classList.add('textClamped');
        toggleTextClamp(true);
        isTextClamped = false;
      }
      
      // Only attach click handler once
      if(descriptionLink && !clickHandlerAttached) {
        descriptionLink.addEventListener('click', function(e) {
          e.preventDefault();
          
          if(isTextClamped){
            console.log('show less');
            toggleTextClamp(true);
            // Add gradient back
            descriptionContainer.classList.add('textClamped');
            isTextClamped = false;
          }
          else {
            console.log('show more');
            toggleTextClamp(false);
            // Remove gradient
            descriptionContainer.classList.remove('textClamped');
            isTextClamped = true;
          }
        });
        clickHandlerAttached = true;
      }
    } else {
      // Remove gradient and reset on desktop
      if(descriptionContainer) {
        descriptionContainer.classList.remove('textClamped');
      }
      const p = document.querySelector(".collection__description p:first-of-type");
      if(p) {
        p.style.display = "";
        p.style.webkitLineClamp = "";
        p.style.webkitBoxOrient = "";
        p.style.overflow = "";
      }
    }
  }

  // Initialize on load
  initTextClamp();

  // // Reinitialize on window resize
  // let resizeTimer;
  // window.addEventListener('resize', function() {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(function() {
  //     initTextClamp();
  //   }, 250);
  // });
});

// Authorized dealer tooltip - hover on desktop, click-toggle on mobile
(function() {
  var lastTouch = false;

  document.addEventListener('touchstart', function() {
    lastTouch = true;
  }, { passive: true });

  document.addEventListener('mousemove', function() {
    lastTouch = false;
  });

  document.addEventListener('click', function(event) {
    var icon = event.target.closest('.authorized-dealer__info-icon');
    if (icon) {
      if (lastTouch) {
        var isActive = icon.classList.contains('tooltip-active');
        document.querySelectorAll('.authorized-dealer__info-icon').forEach(function(el) {
          el.classList.remove('tooltip-active');
        });
        if (!isActive) icon.classList.add('tooltip-active');
      }
    } else {
      document.querySelectorAll('.authorized-dealer__info-icon').forEach(function(el) {
        el.classList.remove('tooltip-active');
      });
    }
  });

  document.addEventListener('mouseover', function(event) {
    if (lastTouch) return;
    var icon = event.target.closest('.authorized-dealer__info-icon');
    if (icon) icon.classList.add('tooltip-active');
  });

  document.addEventListener('mouseout', function(event) {
    if (lastTouch) return;
    var icon = event.target.closest('.authorized-dealer__info-icon');
    var related = event.relatedTarget ? event.relatedTarget.closest('.authorized-dealer__info-icon') : null;
    if (icon && !related) icon.classList.remove('tooltip-active');
  });
})();

(function() {
  if (window.location.pathname !== "/collections/vendors") return;

  document.addEventListener('click', function(e) {
    const productWrap = e.target.closest('.boost-pfs-filter-products .product-wrap');
    if (!productWrap) return;

    const link = productWrap.querySelector('a[href*="/products/"]');
    if (!link) return;

    // Stop Boost from rewriting URL
    e.stopImmediatePropagation();

    window.location.href = link.href;

  }, true); 
})();